
'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity, Keyboard, ScrollView, PanResponder, TextInput} from 'react-native';
import styles from '../style';
import {inject, observer} from "mobx-react";
import {getScreenSize} from "../../../../../common/utils";


let BAR_MARGIN_OFFSET = 17;
let BAR_PADDING_OFFSET = 24;


let BAR_LENGTH = getScreenSize().width - (BAR_MARGIN_OFFSET + BAR_PADDING_OFFSET) * 2;

let BALL_LENGTH  = 30;

let END_DAY = 15;
let START_DAY = 2;

let OFFSET = 0;

@inject(stores => {
    let {searchDataStore} = stores,
        {selectedDays, handleSelectDays, customize, logData} = searchDataStore;

    return {selectedDays, handleSelectDays, customize, logData};
})

@observer
class DayRange extends Component {
    constructor(props) {
        super(props);
    }

    getLeftBallPos () {
        let {selectedDays} = this.props || {};
        let {start} = selectedDays || {};
        let block = BAR_LENGTH / (END_DAY - START_DAY);
        return (start - START_DAY) * block - BALL_LENGTH;
    }

    getRightBallPos () {
        let {selectedDays} = this.props || {};
        let {end} = selectedDays || {};
        let block = BAR_LENGTH / (END_DAY - START_DAY);
        return (end - START_DAY) * block;
    }

    componentWillMount(){
        this._panResponder = PanResponder.create({
            onStartShouldSetPanResponder: (evt, gestureState) => true,
            onPanResponderGrant: (e, gestureState) => {this.rightBallLocationX = e.nativeEvent.locationX},
            onPanResponderMove: (e, gestureState) => {
                let moveLeft = gestureState.vx < 0;
                let ballAnchor = e.nativeEvent.pageX - BAR_MARGIN_OFFSET - this.rightBallLocationX - BALL_LENGTH;
                let ballLeft = this.limitBallLeft(ballAnchor);

                this.rightBall.setNativeProps({
                    style:{
                        left: ballLeft
                    }
                });


                this.setDate({
                    rightBallX: ballLeft
                });

                this.rightBallPos = ballLeft;

                this.setActiveBar();
                this.allBallsMove(ballLeft - BALL_LENGTH - OFFSET, moveLeft, () => {
                    this.rightBall.setNativeProps({
                        style:{
                            left: ballLeft
                        }
                    })
                })
            },
            onPanResponderRelease: this.selectDays
        });
        this._panLeftResponder = PanResponder.create({
            onStartShouldSetPanResponder: () => true,
            onPanResponderGrant: (e) => {this.leftBallLocationX = e.nativeEvent.locationX;},
            onPanResponderMove: (e, gestureState) => {
                let moveRight = gestureState.vx > 0;
                let ballAnchor = e.nativeEvent.pageX - BAR_MARGIN_OFFSET - this.leftBallLocationX;

                let limitedBallAnchor = this.limitBallLeft(ballAnchor);
                let ballLeft = limitedBallAnchor - BALL_LENGTH;

                this.leftBall.setNativeProps({
                    style:{
                        left: ballLeft
                    }
                });

                this.setDate({
                    leftBallX: ballLeft
                });

                this.leftBallPos = ballLeft;
                this.setActiveBar();
                this.allBallsMove(ballLeft, moveRight, () => {
                    this.leftBall.setNativeProps({
                        style:{
                            left: ballLeft
                        }
                    })
                })
            },
            onPanResponderRelease: this.selectDays
        });
    }

    selectDays = () => {
        GodEye.log({
            r: 'time_span_click',
            start: this.startDay,
            end: this.endDay,
            ...this.props.logData
        });
        this.props.handleSelectDays({
            start: this.startDay,
            end: this.endDay
        })
    };

    setActiveBar({allBallsMove}= {}){
        if(allBallsMove) {
            this.activeBar.setNativeProps({
                style:{
                    width: OFFSET,
                    left: this.rightBallPos - OFFSET
                }
            })
        } else {
            this.activeBar.setNativeProps({
                style:{
                    width: this.rightBallPos - this.leftBallPos - BALL_LENGTH,
                    left: this.leftBallPos + BALL_LENGTH
                }
            })
        }
    }

    setDate({leftBallX, rightBallX, allBallsMove}) {
        if (!allBallsMove) {
            this.rightBallText.setNativeProps({
                style: {
                    left: 0
                }
            });
            this.leftBallText.setNativeProps({
                style: {
                    opacity: 1
                }
            });

            if (leftBallX) {
                this.startDay = this.getDay(leftBallX + BALL_LENGTH);
                this.leftBallText.setNativeProps({
                    text: this.startDay + '天'
                });

            }

            if (rightBallX) {
                this.endDay = this.getDay(rightBallX);
                this.rightBallText.setNativeProps({
                    text: this.endDay + '天'
                });
            }
        } else {
            if (rightBallX) {
                let curDay = this.getDay(rightBallX - 2);
                this.leftBallText.setNativeProps({
                    text: curDay + '天',
                });
                this.rightBallText.setNativeProps({
                    text: curDay + '天'
                });
                this.startDay = curDay;
                this.endDay = curDay;
            }

            this.rightBallText.setNativeProps({
                style: {
                    left: -12
                }
            });
            this.leftBallText.setNativeProps({
                style: {
                    opacity: 0
                }
            });
        }
    }

    getDay(ballLeft) {
        let block = BAR_LENGTH / (END_DAY - START_DAY);
        return (Math.round(ballLeft / block) + OFFSET / 2) + 2;
    }

    limitBallLeft(ballLeft) {
        ballLeft = Math.round(ballLeft);
        if (ballLeft < 0) {
            ballLeft = 0
        } else if (ballLeft > BAR_LENGTH) {
            ballLeft = BAR_LENGTH
        }
        return ballLeft;
    }


    allBallsMove(ballLeft, allBallsMark, callback) {
        if (this.rightBallPos <= (this.leftBallPos + BALL_LENGTH + OFFSET) && allBallsMark) {
            let leftTemp = ballLeft ;
            let rightTemp = ballLeft + BALL_LENGTH + OFFSET;

            this.leftBall.setNativeProps({
                style:{
                    left: leftTemp
                }
            });

            this.rightBall.setNativeProps({
                style:{
                    left: rightTemp
                }
            });

            this.setDate({
                allBallsMove: true,
                rightBallX: rightTemp
            });

            this.leftBallPos = leftTemp;
            this.rightBallPos = rightTemp;
            this.setActiveBar({allBallsMove: true});

        } else {
            callback();
        }
    }

    render() {
        let {selectedDays, customize} = this.props || {};
        let {start, end} = selectedDays || {};

        let disable = customize;

        this.startDay = start;
        this.endDay = end;
        this.leftBallPos = this.getLeftBallPos();
        this.rightBallPos = this.getRightBallPos();
        this.ballWidth = this.rightBallPos - this.leftBallPos - BALL_LENGTH;

        return (
            <View style={styles.searchFilterBlock}>
                <Text style={styles.searchFilterBlockTitle}>出行天数</Text>
                <View style={styles.searchDay}>
                    <View style={[styles.searchDayLeft, {left: this.leftBallPos}]} ref={(e) => {this.leftBall = e}}>
                        <TextInput
                            style={[styles.searchDayText, disable ? styles.searchDayDisableText: {}]}
                            ref={(e) => {this.leftBallText = e}}
                            editable={false}
                            value={start + '天'}
                        />
                        <View style={[styles.searchBallLeft,disable ? styles.searchDisable: {}]}{...this._panLeftResponder.panHandlers} />
                    </View>

                    <View style={[styles.searchDayRight, {left: this.rightBallPos}]} ref={(e) => {this.rightBall = e}}>
                        <TextInput
                            style={[styles.searchDayText, disable ? styles.searchDayDisableText: {}]}
                            ref={(e) => {this.rightBallText = e}}
                            editable={false}
                            value={end + '天'}
                        />
                        <View style={[styles.searchBallRight, disable ? styles.searchDisable: {}]}{...this._panResponder.panHandlers} />
                    </View>

                    <View style={styles.searchDayBar}>
                        <View style={[styles.searchDayActiveBar,{left: this.leftBallPos + BALL_LENGTH, width: this.ballWidth},disable ? styles.searchDisable: {}]} ref={(e)=>{this.activeBar = e}}/>
                    </View>
                </View>
            </View>
        )
    }
}

export default DayRange;
